import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';

/**
 * Guard to check if user has admin role
 * Redirects to home if user is not an admin
 */
export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.currentUser$.pipe(
    take(1),
    map((user) => {
      // Check both single role and roles array for admin
      const isAdmin =
        (user && user.role === 'admin') ||
        (user && user.roles && user.roles.includes('admin'));

      if (isAdmin) {
        console.log('✅ Admin access granted');
        console.log('🔍 User role:', user.role);
        console.log('🔍 User roles:', user.roles);
        return true;
      }

      console.log('❌ Access denied - Admin role required');
      console.log('🔍 User role:', user?.role);
      console.log('🔍 User roles:', user?.roles);
      router.navigate(['/home']);
      return false;
    })
  );
};

/**
 * Factory function to create a role guard for specific roles
 */
export const roleGuard = (
  allowedRoles: Array<'admin' | 'customer'>
): CanActivateFn => {
  return (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.currentUser$.pipe(
      take(1),
      map((user) => {
        // Check both single role and roles array
        const hasAllowedRole =
          (user && user.role && allowedRoles.includes(user.role)) ||
          (user &&
            user.roles &&
            user.roles.some((role) =>
              allowedRoles.includes(role as 'admin' | 'customer')
            ));

        if (hasAllowedRole) {
          console.log(`✅ Role-based access granted`);
          console.log(`🔍 User role: ${user.role}`);
          console.log(`🔍 User roles: ${user.roles}`);
          return true;
        }

        console.log(
          `❌ Access denied - Required roles: ${allowedRoles.join(' or ')}`
        );
        console.log(`🔍 User role: ${user?.role}`);
        console.log(`🔍 User roles: ${user?.roles}`);
        router.navigate(['/home']);
        return false;
      })
    );
  };
};
